import { RUNTIME_API_BASE_URL } from './runtimeApi';

const requestedMode = process.env.EXPO_PUBLIC_DIAGRAM_API_MODE;

export const DIAGRAM_API_MODE = requestedMode === 'staging' ? 'staging' : 'fixture';

const resolvedBaseUrl = DIAGRAM_API_MODE === 'staging' ? RUNTIME_API_BASE_URL : null;

export const DIAGRAM_API_CONFIG = {
  mode: DIAGRAM_API_MODE,
  baseUrl: resolvedBaseUrl,
  requiresHttps: DIAGRAM_API_MODE === 'staging',
  endpoints: {
    diagramSpecs: '/api/v1/diagram-specs',
    renderJobs: '/api/v1/diagram-render-jobs',
  },
};

export const assertDiagramApiConfiguration = () => {
  return null;
};
